module.exports = __webpack_public_path__ + "img/AccountBoxOutlined.8af68c4b.svg";